import React from 'react';
import validator from 'validator';

import {
	getInscricaoInfos,
	saveInscricao,
} from './services/inscricao-service';
import notification from './Notification';
import {
	pretty,
} from './services/utils';
import Footer from './Footer';
import './styles/inscrever-trabalho.css';

class InscreverTrabalho extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			categoria: null,
			textoTrabalho: '',
			loading: true,
			error: null,
			inscricaoInfos: {},
		};
	}

	async componentWillMount() {
		try {
			const inscricaoInfos = await getInscricaoInfos(this.props.match.params.evento_id);
			this.setState({ inscricaoInfos, loading: false, error: null });
		} catch (error) {
			this.setState({ error: { message: 'O evento está indisponível.' } });
		}
	}

	async onSubmitInscricao(event) {
		event.preventDefault();

		const formData = new FormData(event.target);
		formData.append('evento_id', this.props.match.params.evento_id);

		const categoria = this.state.categoria;
		if (!validator.isLength(formData.get('texto_trabalho').replace(/[\r\n]/g, ''), { min: categoria.minimo_caracteres, max: categoria.maximo_caracteres })) {
			notification.show('Texto inválido.', true);
			return;
		}

		try {
			const result = await saveInscricao(formData);
			this.props.history.push(`/finalizar-inscricao/${this.props.match.params.evento_id}/${result.token_inscricao}`);
		} catch (error) {
			notification.show(error.message, true);
		}
	}

	onChangeCategoria(event) {
		const categoria = this.state.inscricaoInfos.categorias[event.target.value];
		this.setState({ categoria });
	}

	async onChangeArquivoTrabalho(event, tamanho_maximo) {
		const files = event.target.files;
		if (files.length > 0) {
			const file = files[0];
			if (file.size > tamanho_maximo) {
				event.target.value = null;
			}
		}
	}

	_renderUploadTrabalho(categoria) {
		return (
			<div>
				<label htmlFor="arquivo_trabalho">Arquivo (máx. {pretty(categoria.tamanho_maximo_arquivo)})*</label>
				<input name="arquivo_trabalho" id="arquivo_trabalho" type="file" required={true} onChange={e => this.onChangeArquivoTrabalho(e, categoria.tamanho_maximo_arquivo)} accept={categoria.extensoes_permitidas} />
			</div>
		);
	}

	_renderTextoTrabalhoCaracteres(caracteres, categoria) {
		let className;
		if (caracteres > categoria.maximo_caracteres) {
			className = ' error-text';
		} else if (caracteres < categoria.minimo_caracteres) {
			className = ' info-text';
		} else {
			className = ' success-text';
		}

		return (
			<div className="row caracteres-trabalho">
				<div className="column column-75">
					O texto deve ter entre {categoria.minimo_caracteres} e {categoria.maximo_caracteres} caracteres.
				</div>
				<div className={'column column-25 text-right' + className}>
					{caracteres} de {categoria.maximo_caracteres}
				</div>
			</div>
		);
	}

	_renderComponenteInscricao() {
		const {
			categoria,
			textoTrabalho,
			inscricaoInfos,
		} = this.state;

		return (
			<div>
				<h3>{inscricaoInfos.evento.nome}</h3>
				<div>
					{inscricaoInfos.evento.observacoes}
				</div>
				<hr />
				<form onSubmit={this.onSubmitInscricao.bind(this)}>
					<input type="hidden" value={inscricaoInfos._csrf_token} name="_csrf" />
					<fieldset>
						<legend>
							<h4 className="color-primary">Informações do autor</h4>
						</legend>

						<div className="row">
							<div className="column column-75">
								<label htmlFor="nome_autor">Nome*</label>
								<input type="text" placeholder="Ex.: João Paulo" maxLength={100} id="nome_autor" name="nome_autor" required={true} autoComplete="off" />
							</div>
							<div className="column column-25">
								<label htmlFor="data_nascimento_autor">Data nascimento*</label>
								<input type="date" placeholder="Ex.: 01/12/1894" id="data_nascimento_autor" name="data_nascimento_autor" required={true} autoComplete="off" />
							</div>
						</div>

						<div className="row">
							<div className="column column-40">
								<label htmlFor="rg_autor">RG/CPF*</label>
								<input type="text" maxLength={14} placeholder="Ex.: RG ou CPF (000.000.000-00)" id="rg_autor" name="rg_autor" required={true} autoComplete="off" />
							</div>
							<div className="column column-60">
								<label htmlFor="email_autor">E-mail*</label>
								<input type="email" placeholder="Ex.: joao@exemplo.com" maxLength={50} id="email_autor" name="email_autor" required={true} autoComplete="off" />
							</div>
						</div>

						<div>
							<label htmlFor="cidade_autor">Cidade*</label>
							<input type="text" placeholder="Ex.: Porto Alegre" maxLength={100} id="cidade_autor" name="cidade_autor" required={true} autoComplete="off" />
						</div>
					</fieldset>

					<fieldset>
						<legend>
							<h4>Informações da entidade</h4>
						</legend>

						<div>
							<label htmlFor="entidade_id">Entidade Formadora*</label>
							<select id="entidade_id" name="entidade_id" defaultValue="" required={true}>
								<option value="" disabled={true}> -- Selecione a entidade -- </option>
								{
									inscricaoInfos.entidades.map((x, index) => <option key={index} value={x.entidade_id}>{x.nome}</option>)
								}
							</select>
						</div>

						<div>
							<label htmlFor="email_responsavel_entidade">E-mail do Responsável da Entidade Formadora*</label>
							<input type="email" placeholder="Ex.: joao@exemplo.com" maxLength={100} id="email_responsavel_entidade" name="email_responsavel_entidade" required={true} autoComplete="off" />
						</div>

						<div>
							<label htmlFor="cidade_entidade">Cidade da Entidade Formadora*</label>
							<input type="text" placeholder="Ex.: Porto Alegre" maxLength={100} id="cidade_entidade" name="cidade_entidade" required={true} autoComplete="off" />
						</div>

						<div>
							<label htmlFor="empresa_entidade">Empresa Contratante*</label>
							<input type="text" placeholder="Ex.: SETREM" maxLength={100} id="empresa_entidade" name="empresa_entidade" required={true} autoComplete="off" />
						</div>

						<div>
							<label htmlFor="cidade_empresa_entidade">Cidade da Empresa Contratante*</label>
							<input type="text" placeholder="Ex.: Três de Maio" maxLength={100} id="cidade_empresa_entidade" name="cidade_empresa_entidade" required={true} autoComplete="off" />
						</div>
					</fieldset>

					<fieldset>
						<legend>
							<h4>Informações do trabalho</h4>
						</legend>

						<div>
							<label htmlFor="titulo_trabalho">Título*</label>
							<input type="text" placeholder="Ex.: Título do trabalho" maxLength={200} id="titulo_trabalho" name="titulo_trabalho" required={true} autoComplete="off" />
						</div>

						<div>
							<label htmlFor="categoria_id">Categoria*</label>
							<select id="categoria_id" name="categoria_id" defaultValue="" required={true} onChange={event => this.onChangeCategoria(event)}>
								<option value="" disabled={true}> -- Selecione a categoria -- </option>
								{
									Object.keys(inscricaoInfos.categorias).map((x, index) => <option key={index} value={x}>{inscricaoInfos.categorias[x].nome}</option>)
								}
							</select>
						</div>

						{
							categoria &&
							<div>
								{
									categoria.observacao ?
										<div style={{ paddingBottom: 16 }}>
											<label>Observação</label>
											{categoria.observacao}
										</div> :
										<div />
								}
								{
									categoria.upload ?
										this._renderUploadTrabalho(categoria) :
										<div />
								}
								<div>
									<label htmlFor="texto_trabalho">{categoria.label_texto_trabalho || 'Texto'}*</label>
									<textarea id="texto_trabalho" name="texto_trabalho" className="texto-trabalho" autoComplete="off" required={true}
										value={textoTrabalho} onChange={e => this.setState({ textoTrabalho: e.target.value })}></textarea>
									{this._renderTextoTrabalhoCaracteres(textoTrabalho.replace(/[\r\n]/g, '').length, categoria)}
								</div>
								{
									categoria.label_campo_extra ?
										<div>
											<label htmlFor="campo_extra_trabalho">{categoria.label_campo_extra}*</label>
											<input type="text" maxLength={200} id="campo_extra_trabalho" name="campo_extra_trabalho" required={true} autoComplete="off" />
										</div> :
										<div />
								}
							</div>
						}
					</fieldset>

					<div>
						<input type="checkbox" id="confirmar_autorizacao" name="confirmar_autorizacao" required={true} />
						<label className="label-inline" htmlFor="confirmar_autorizacao">
							Declaro ter conhecimento do Regulamento do Concurso Literário para Aprendizes.
							<br />
							Declaro, sob as penas da lei, que o presente trabalho é inédito.
							<br />
							Autorizo a comissão organizadora a publicar o presente trabalho se houver interesse.
						</label>
					</div>

					<br />
					<input className="button-primary button-large" type="submit" value="Enviar trabalho" />
				</form>
			</div>
		);
	}

	render() {
		const {
			loading,
			error,
		} = this.state;

		return (
			<div className="wrapper">

				<nav className="app-navigation">
					<section className="container">
						<a className="app-navigation-title" href="/">
							<h1 className="app-title">Fórum Gaúcho de Aprendizagem Profissional - FOGAP</h1>
						</a>
						<ul className="app-navigation-list float-right">
							<li className="app-navigation-item">
								<a className="app-navigation-link" onClick={() => this.props.history.push('/login')}>Admin</a>
							</li>
						</ul>
					</section>
				</nav>
				<div className="container app-body">
					{
						error ?
							<div>{error.message}</div> :
							loading ?
								<div>Carregando...</div> :
								this._renderComponenteInscricao()
					}
				</div>
				<footer className="footer">
					<section className="container">
						<Footer />
					</section>
				</footer>
			</div>
		);
	}
}

export default InscreverTrabalho;